import Table from './src/table.vue'

export default Table
